// /dashboard/:orgSlug/vocabulary — Figma frame 16 vocabulary health (34:2127).
// Owner: screens-content, US-122.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { VocabularyHealthScreen } from "../screens/content/VocabularyHealthScreen";

export const vocabularyRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/dashboard/$orgSlug/vocabulary",
  staticData: { title: "Vocabulary health" },
  component: VocabularyRoute,
});

function VocabularyRoute() {
  const { orgSlug } = vocabularyRoute.useParams();
  return (
    <VocabularyHealthScreen orgSlug={orgSlug} />
  );
}
